import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Camera Tool',
      href: '/de/Downloadbereich/Desktop_Software/Instar_Camera_Tool/',
    },
    {
      text: 'InstarVision',
      href: '/de/Downloadbereich/Desktop_Software/InstarVision/',
    },
    {
      text: 'InstarVision (macOS)',
      href: '/de/Downloadbereich/Desktop_Software/InstarVision_for_macOS/',
    },
    {
      text: 'InstarVision (Metro)',
      href: '/de/Downloadbereich/Desktop_Software/InstarVision_Metro/',
    },
    {
      text: 'Desktop Software',
      href: '/de/Downloadbereich/Desktop_Software/',
    },
    {
      text: '◄ Downloadbereich',
      href: '/de/Downloadbereich/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={11}
        aria-label="Downloadbereich for your INSTAR IP Camera"
      />
      <EuiSpacer />
    </Fragment>
  );
}